/**
 * Preset reasons shown on the rider's "Cancel trip" form. The labels are only
 * shown: a hand-back sends the reason's InGo name (`HAND_BACK_REASONS` in
 * `riderWork.js`, keyed by `id`), plus the rider's own note.
 */
export const DRIVER_CANCEL_REASONS = [
  { id: 'breakdown', label: 'Breakdown' },
  { id: 'client_not_reachable', label: 'Client not reachable' },
  { id: 'wrong_address', label: 'Wrong / unclear address' },
  { id: 'customer_refused', label: 'The customer refused the delivery' },
  { id: 'safety', label: 'Safety concern' },
  { id: 'traffic_blocked', label: 'Road blocked / cannot reach' },
  { id: 'other', label: 'Other' },
];
